import React from 'react';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import ConstValues from 'utils/const';
import Button from '@material-ui/core/Button';
import Breadcrumbs from '../utils/Breadcrumbs';
import UserReminderTable from './UserReminderTable';
import UserInviteTable from './UserInviteTable';
import Loading from 'components/pure/utils/Loading';
import AdminWelcomeEmailActions from 'actions/admin/AdminWelcomeEmailActions';

require('styles/admin/AdminWelcomeEmail.styl');

const {adminWelcomeEmailTypes: TYPES} = ConstValues;

const allSelected = list => {
  return !list.findEntry(v => !v);
};

/**
 * Renders the Admin Welcome Email page
 */
class AdminWelcomeEmail extends React.PureComponent {
  renderTable(type, users) {
    // eslint-disable-next-line
    switch (type) {
      case TYPES.reminder:
        return (
          <UserReminderTable users={users} selected={this.props.AdminWelcomeEmailStore.selected} />
        );
      case TYPES.invite:
        return (
          <UserInviteTable users={users} selected={this.props.AdminWelcomeEmailStore.selected} />
        );
    }
  }

  welcomeEmailSendingStatus() {
    return `Sending`;
  }

  renderTableWithControls(type) {
    return (
      <div className="section-container">
        <div className="table-container">
          {this.renderTable(type, this.props.AdminWelcomeEmailStore.lists.get(type))}
        </div>
        <div className="controls">
          <Button
            variant="contained"
            color="primary"
            className="ev-button"
            onClick={() => {
              const isSending = this.props.AdminWelcomeEmailStore.sending.get(type);
              if (!isSending) {
                AdminWelcomeEmailActions.sendWelcome(type);
              }
            }}>
            {this.props.AdminWelcomeEmailStore.sending.get(type)
              ? this.welcomeEmailSendingStatus()
              : this.props.AdminWelcomeEmailStore.sent.get(type)
              ? 'Sent!'
              : this.props.AdminWelcomeEmailStore.error.get(type)
              ? 'Error'
              : type === TYPES.invite
              ? 'Send Invites'
              : 'Send Reminders'}
          </Button>
          <FormControlLabel
            classes={{label: 'select-all-checkbox-label'}}
            control={
              <Checkbox
                checked={allSelected(this.props.AdminWelcomeEmailStore.selected.get(type))}
                onChange={() => AdminWelcomeEmailActions.selectAllItems(type)}
              />
            }
            label="Select All"
          />
        </div>
      </div>
    );
  }

  render() {
    const breadcrumbsLinks = [{name: 'Users', url: '/admin/users'}];
    const invites = this.props.AdminWelcomeEmailStore.lists.get(TYPES.invite);
    const reminders = this.props.AdminWelcomeEmailStore.lists.get(TYPES.reminder);
    return (
      <div className="admin-welcome-email admin-users">
        <Breadcrumbs links={breadcrumbsLinks} />
        <h1>Welcome Email</h1>
        {this.props.AdminWelcomeEmailStore.get('loading') ? (
          <Loading />
        ) : (
          <div>
            {invites.size === 0 ? null : (
              <div className="invites-section">
                <h3>Need Invites</h3>
                <p>
                  The following users have not yet received a setup email from Coach. Check boxes
                  next to anybody who you're ready to invite, and click the button.
                </p>
                {this.renderTableWithControls(TYPES.invite)}
              </div>
            )}
            {reminders.size === 0 ? null : (
              <div className="reminders-section">
                <h3 id="reminders">Need Reminders</h3>
                <p>
                  The following users were invited at least 24 hours ago and not yet responded.
                  Check boxes next to anybody who you'd like to send a reminder to, and click the
                  button.
                </p>
                {this.renderTableWithControls(TYPES.reminder)}
              </div>
            )}
            {reminders.size === 0 && invites.size === 0 ? (
              <p>All users are active and no invites are needed.</p>
            ) : null}
          </div>
        )}
      </div>
    );
  }
}

export default AdminWelcomeEmail;
